import React from "react";
import {useSelector} from "react-redux";
import RootState from "../../../redux/states/root.state";
import { HeaterIcon } from "../../../assets/svg/svg";

const TempDiffCard: React.FC = () => {
    const {spasWithTempDifference} = useSelector((state: RootState) => state.dashboard);
    const length = spasWithTempDifference?.spa_guids?.length??0;
  return (
    <div className="kpi-card" id="temp-diff">
      <div className="kpi-head">
        <span className="kpi-icon"><HeaterIcon/></span>
        <span className="kpi-title">Temp Difference</span>
      </div>
      <div className="kpi-body">
        <strong className="kpi-value">{length}</strong>
        <span className="kpi-unit">{length===1?'spa':'spas'}</span>
      </div>
      <span className="kpi-caption">Difference &gt; 20°F (10°C)</span>
    </div>
);
};

export default TempDiffCard;
